import Link from "next/link";
import { FC, Fragment } from "react";
import uniqid from "uniqid";
import styles from "./styles.module.scss";
import classNames from "classnames";
import { usePathname } from "next/navigation";

export interface BreadCrumbProps {
  data: {
    url: string;
    label: string;
  }[];
  className?: string;
}

export const BreadCrumb: FC<BreadCrumbProps> = ({ data = [], className }) => {
  const pathname = usePathname();

  return (
    <div className={classNames(styles.bread_crumb, className)}>
      {data.map(({ url, label }, index) => (
        <Fragment key={uniqid()}>
          <Link
            className={classNames({ [styles.active]: pathname === url })}
            href={url}
          >
            {label}
          </Link>
          {index < data.length - 1 && <span>/</span>}
        </Fragment>
      ))}
    </div>
  );
};
